import { useState, useEffect, useCallback } from 'react';

const useImagenSegura = (url, options = {}) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(!options.lazy);
  const [error, setError] = useState(null);

  const loadImage = useCallback(async () => {
    if (!url) {
      setError('URL no proporcionada');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No hay token de autenticación');
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error('No autorizado para ver esta imagen');
        } else if (response.status === 404) {
          throw new Error('Imagen no encontrada');
        } else {
          throw new Error(`Error al cargar imagen: ${response.status}`);
        }
      }

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      setImageUrl(objectUrl);
      setLoading(false);

      return objectUrl;
    } catch (err) {
      console.error('Error cargando imagen segura:', err);
      setError(err.message);
      setLoading(false);
      return null;
    }
  }, [url]);

  const revokeUrl = useCallback(() => {
    if (imageUrl && imageUrl.startsWith('blob:')) {
      URL.revokeObjectURL(imageUrl);
      setImageUrl(null);
    }
  }, [imageUrl]);

  useEffect(() => {
    if (options.lazy) {
      setLoading(false);
      return;
    }

    if (!url) {
      setLoading(false);
      return;
    }

    let currentObjectUrl;
    
    loadImage().then(objectUrl => {
      currentObjectUrl = objectUrl;
    });

    return () => {
      if (currentObjectUrl && currentObjectUrl.startsWith('blob:')) {
        URL.revokeObjectURL(currentObjectUrl);
      }
    };
  }, [url, options.lazy, loadImage]);

  return {
    imageUrl,
    loading,
    error,
    triggerLoad: loadImage,
    revokeUrl
  };
};

export default useImagenSegura;